<script setup lang="ts">
  import { ref, onMounted } from 'vue';
  import { useRouter } from 'vue-router';
  import { Button, Avatar, Text } from '@ui-kit';
  import LoginPageFooter from './LoginPageFooter.vue';

  const emit = defineEmits(['clearUser']);
  const {
    firstName,
    lastName,
    store,
    avatar,
  } = defineProps<{
    firstName: string;
    lastName?: string;
    store: string;
    avatar?: string;
  }>();
  
  const { push } = useRouter();

  const timer = ref(10);

  onMounted(() => {
    const timerId = setInterval(() => {
      if (timer.value === 0) {
        clearInterval(timerId);

        emit('clearUser');
      } else {
        timer.value = timer.value - 1;
      }
    }, 1000);
  });

  const handleApprove = () => push('welcome');
</script>

<template>
  <LoginPageFooter data-testid="login-user-info">
    <div class="login-page__user">
      <Avatar class="login-page__avatar" :first-name="firstName" :last-name="lastName" :avatar="avatar"/>
      <div class="login-page__info">
        <Text class="login-page__name" font="body-medium-16" data-testid="login-user-info-name">{{ $t('Добро пожаловать') }}, {{ firstName }}!</Text>
        <Text class="login-page__text" font="body-regular-14" color="secondary" data-testid="login-user-info-shop">{{ store }}</Text>
      </div>
    </div>
    <Button
      data-testid="user-info-confirm"
      class="login-page__enter-btn"
      size="l"
      @click="handleApprove"
    >
      {{ $t('Подтвердите вход') }} {{ timer }}
    </Button>
    <Text class="login-page__text" font="body-regular-14" color="secondary">{{ $t('Отсканируйте новый qr-код если это не вы') }}</Text>
  </LoginPageFooter>
</template>

<style scoped>
  .login-page__user {
    display: flex;
    width: 100%;
    gap: 16px;
    align-items: center;
  }

  .login-page__avatar {
    flex-shrink: 0;
  }

  .login-page__info {
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .login-page__info :deep(.text) {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .login-page__name {
    color: #141414;
  }

  .login-page__text {
    color: #828690;
  }

  .login-page__enter-btn {
    margin-top: 24px;
    width: 100%;
  }
</style>